<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import Chart from '@/components/charts/Chart'

export default {
  name: 'OrderRateChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    labelField: {
      type: String,
      default: 'frequency'
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.report.map(item => {
          if(item[this.labelField] === 'adReach') {
            return '広告接触'
          } else if(item[this.labelField] === 'nonAdReach') {
            return '非接触'
          } else {
            return item[this.labelField]
          }
        }),
        datasets: [
          {
            label: '注文率',
            borderWidth: 2,
            backgroundColor: ({dataIndex}) => {
              if (dataIndex === 7) {
                return '#1F78B4'
              } else if (dataIndex === 8) {
                return "#B7B7B7"
              } else {
                return '#A6CEE3'
              }
            },
            data: this.report.map(item => {
              const base = 10 ** 2
              return Math.round((item.orderRate * 100) * base) / base
            }),
            yAxisID: 'orderRate'
          }
        ]
      }
    },
    options () {
      return {
        plugins: {
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                if (tooltipItem.raw === 0) {
                  return ''
                }
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                return `${label}: ${value}%`
              }
            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true
          },
          orderRate: {
            stacked: false,
            position: 'left',
            suggestedMin: 0,
            ticks: {
              callback (value) {
                return `${value.toLocaleString()}%`
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
